<article class="tooltip-layout1"
         (click)="onVoid($event)">

  <div class="tooltip-wrap">

    <app-link-popup-item-word *ngFor="let word of listWord; let idx = index"
                              [word]="word"
                              [btnClose]="idx === 0"
                              (close)="onCloseWord($event)">
    </app-link-popup-item-word>

    <app-link-popup-item-dialect *ngFor="let dialect of listDialect; let idx = index"
                                 [dialect]="dialect"
                                 [btnClose]="listWord.length === 0 && idx === 0"
                                 (close)="onCloseDialect($event)">
    </app-link-popup-item-dialect>

    <div *ngIf="getMoreTxt()"
         class="tooltip-item">
      <div class="tooltip-link-box">
        <a class="tooltip-link-btn"
           (click)="onCloseMore($event)">
          <span class="txt more">{{ getMoreTxt() }}</span>
          <span class="txt">전체 보기</span>
          <i class="ic ic-link"></i>
        </a>
      </div>
    </div>

    <div *ngIf="IsLoading"
         class="reload-icon">
      <img src="assets/img/loading_icon.gif">
    </div>

  </div>
</article>
